import React from 'react';

const LoadingIndicator = ({ message = 'Loading...', className = '' }) => (
  <div className={className}>
    <i className="animate-spin fa fa-spinner" /> {message}
  </div>
);

export default LoadingIndicator; 